import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { NavaidService } from '../service/navaid.service';
var DeleteNavaidComponent = /** @class */ (function () {
    function DeleteNavaidComponent(_matDialogRef, data, _NavaidService) {
        this._matDialogRef = _matDialogRef;
        this._NavaidService = _NavaidService;
        this.isLoading = false;
        this.navaidId = data.navaidId;
    }
    DeleteNavaidComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
    };
    DeleteNavaidComponent.prototype.close = function (data) {
        this._matDialogRef.close(data);
    };
    DeleteNavaidComponent.prototype.delete = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.isLoading = true;
                        return [4 /*yield*/, this._NavaidService.deleteNavaid(this.navaidId)];
                    case 1:
                        _a.sent();
                        this.isLoading = false;
                        this.close({ success: true, navaidId: this.navaidId });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.close({ success: false, error: e_1 });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DeleteNavaidComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    return DeleteNavaidComponent;
}());
export { DeleteNavaidComponent };
